import { Routes } from '@angular/router';
import { IndexPage } from './pages/index/index.page';
import { MarketplacePage } from './pages/marketplace/marketplace.page';
import { ViewCreaturePage } from './pages/creature/view/view-creature.page';
import { ConnectWalletPage } from './pages/wallet/connect-wallet.page';
import { ListCreaturePage } from './pages/creature/list/list-creature.page';
import { PageComponent } from './pages/page/page.component';
import { ContinueBreedingPage } from './pages/creature/continue-breeding/continue-breeding.page';
import { PrivacyPolicyPage } from './components/privacy-policy/privacy-policy-page.component';
import { TermsOfServicePage } from './components/terms-of-service/terms-of-service-page.component';
import { CookiePolicyPage } from './components/cookie-policy/cookie-policy-page.component';
import { ListCreatureBreedingPage } from './pages/creature-breeding/list/list-creature-breeding.page';

export const routes: Routes = [
    {
        path: ':lang',
        component: PageComponent,
        children: [
            {
                path: 'index',
                component: IndexPage,
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicyPage
            },
            {
                path: 'terms-of-service',
                component: TermsOfServicePage
            },
            {
                path: 'cookie-policy',
                component: CookiePolicyPage
            },
            {
                path: 'marketplace',
                component: MarketplacePage
            },
            {
                path: 'marketplace/view/:id',
                component: ViewCreaturePage
            },
            {
                path: 'my-creatures',
                component: ListCreaturePage,
            },
            {
                path: 'my-creatures/view/:id',
                component: ViewCreaturePage
            },
            {
                path: 'my-creatures/view/:creature-1-id/continue-breeding/:creature-2-id/:breeding-order-id',
                component: ContinueBreedingPage
            },
            {
                path: 'my-creatures/breeding',
                component: ListCreatureBreedingPage,
            },
            {
                path: 'connect-wallet',
                component: ConnectWalletPage
            },
            {
                path: '',
                redirectTo: 'index',
                pathMatch: 'full',
            }
        ]
    },
    {
        path: '',
        redirectTo: 'en',
        pathMatch: 'full',
    },
    {
        path: ':lang',
        redirectTo: ':lang/index',
        pathMatch: 'full',
    },
];